import { FreeMode } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { useRef } from "react";
import { useHeaderIsLoading } from "../../../(general-header)/header/hooks";

export type TabItem = {
  id: string;
  label: string;
  img?: string;
  alt?: string;
};

const tabsData: TabItem[] = [
  {
    id: "thisWeek",
    label: "Active Competitions",
    // img: "/assets/images/subscription-competitions/botb-pass-coin.png",
    alt: "icon test",
  },
  {
    id: "pastWinners",
    label: "Past Winners",
    // img: "/assets/images/subscription-competitions/botb-pass-coin.png",
    alt: "icon test 2",
  },
];

type CategoryMenuProps = {
  activeTab: string;
  onSelect: (id: string) => void;
};

const CategoryMenu = ({ activeTab, onSelect }: CategoryMenuProps) => {
  const isHeaderLoading = useHeaderIsLoading();
  const swiperRef = useRef(null);

  return (
    <div
      id={"category-menu"}
      className={`w-full bg-white shadow-[0_1.5px_8px_0_rgba(0,0,0,0.20)] sticky z-40 min-h-12 lg:min-h-[72px]}`}
      style={{
        top: `var(--header-height)`,
      }}>
      <div className={"w-full max-w-[1388px] lg:px-6 mx-auto"}>
        <Swiper
          onSwiper={swiper => {
            swiperRef.current = swiper;
          }}
          className={"max-lg:!px-2"}
          slidesPerView={"auto"}
          spaceBetween={0}
          centerInsufficientSlides={true}
          modules={[FreeMode]}
          freeMode={true}>
          {tabsData.map(tab => (
            <SwiperSlide
              key={tab.id}
              className="flex items-center justify-center min-h-auto !w-auto whitespace-nowrap mr-3 lg:mr-4 last:mr-0">
              <button
                type="button"
                onClick={() => onSelect(tab.id)}
                className={`min-h-12 lg:min-h-[72px] flex-center gap-2 lg:gap-3 transition ease-in-out duration-200 font-jost text-sm font-medium leading-5 lg:text-base lg:leading-[22px] relative m-0 px-2 lg:px-3 border-b-2 border-solid cursor-pointer overflow-hidden
                  ${activeTab === tab.id ? "border-b-primary text-primary" : "border-b-transparent text-secondary"}`}>
                {tab.img && <img className="size-6 lg:size-8" src={tab.img} alt={tab.alt} width={24} height={24} />}

                {tab.label}
              </button>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default CategoryMenu;
